export default __webpack_public_path__ + "static/media/r7.58bc4097.jpeg";